// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Contact from "./Contact";
import About from "./About";
import Service from "./Service";
import News from "./News";
import AidanWorlds from "./AidanWorlds";
import AidanCottbus from "./AidanCottbus";
import WajdiCoach2026 from "./WajdiBouallegueCoaching2025-2026";
import ScrollToTop from "./Effects/SroolToTop";
import NotFound from "./NotFound";
import "./i18n";

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Service />} />
        <Route path="/news" element={<News />} />
        <Route
          path="/news/aidan-li-2025-artistic-gymnastics-world-championships"
          element={<AidanWorlds />}
        />
        <Route
          path="/news/aidan-li-2026-artistic-gymnastics-cottbus-world-cup"
          element={<AidanCottbus />}
        />
        <Route
          path="/news/wajdi-bouallegue-coaching-2025-2026"
          element={<WajdiCoach2026 />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
